/* eslint-disable react/prop-types */ // TODO: add props
import Keypad from './Keypad';
import LatexKeypadButton from './LatexKeypadButton';
import KeypadButton from './KeypadButton';

const SimpleMath = ({ onKeyPressCmd, onKeyPressWrite }) => (
  <Keypad className="basic-math" {...{ onKeyPressCmd, onKeyPressWrite }}>
    <div>
      <KeypadButton label="&lt;" />
      <KeypadButton label="&gt;" />

      <KeypadButton label="[" />
      <KeypadButton label="]" />
      <KeypadButton label="(" />
      <KeypadButton label=")" />
    </div>

    <div>
      <KeypadButton label="&le;" />
      <KeypadButton label="&ge;" />

      <LatexKeypadButton label="x" />
      <LatexKeypadButton label="y" />
      <LatexKeypadButton label="\overline{x}" />
      <LatexKeypadButton label="x^2" value="^2" />
    </div>

    <div>
      <KeypadButton label="≈">{/*"&#8776;"*/}</KeypadButton>
      <KeypadButton label="≠"> {/* "&ne;" */}</KeypadButton>

      <LatexKeypadButton label="\sqrt{}" />
      <LatexKeypadButton label="\frac{}{}" />
      <LatexKeypadButton label="x^{}" />
      <LatexKeypadButton label="x_{}" />
    </div>

    <div>
      <KeypadButton label="$" />
      <KeypadButton label="%" />

      <LatexKeypadButton label="x\frac{}{}" />
      <LatexKeypadButton label="\binom{}{}" />
      <KeypadButton label="" />
      <KeypadButton label="&pi;" />
    </div>

    <div>
      <LatexKeypadButton label="\angle" />
      <LatexKeypadButton label="\circ" />
    </div>
  </Keypad>
);

export default SimpleMath;
